import { useEffect, useState } from 'react';

export type ToastKind = 'info' | 'ok' | 'err';
export type Toast = { id: number; msg: string; kind: ToastKind };

let counter = 0;
let toasts: Toast[] = [];
const subscribers = new Set<(t: Toast[]) => void>();
const emit = () => subscribers.forEach((s) => s(toasts));

const DURATION = 2600;

export function showToast(msg: string, kind: ToastKind = 'info'): void {
  const t: Toast = { id: ++counter, msg, kind };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((x) => x.id !== t.id);
    emit();
  }, DURATION);
}

export function useToasts(): Toast[] {
  const [, force] = useState(0);
  useEffect(() => {
    const sub = () => force((x) => x + 1);
    subscribers.add(sub);
    return () => { subscribers.delete(sub); };
  }, []);
  return toasts;
}
